import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import axios from "axios";
import { getIcons } from "../../Constant/Constant";
import { showSuccessToast } from "../../Constant/Notification";
import { ToastContainer } from "react-toastify";
import { DasboardService } from "../../Services/DashboardService";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const months = [
  { value: "1", label: "January" },
  { value: "2", label: "February" },
  { value: "3", label: "March" },
  { value: "4", label: "April" },
  { value: "5", label: "May" },
  { value: "6", label: "June" },
  { value: "7", label: "July" },
  { value: "8", label: "August" },
  { value: "9", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

const StackedBarChart = ({ view }) => {
  const icon = getIcons();
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });
  const [loading, setLoading] = useState(true);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [targetValue, setTargetValue] = useState("");
  const [targetValueOfTheMonth, setTargetValueOfTheMonth] = useState("");

  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  useEffect(() => {
    const year = new Date().getFullYear();
    setCurrentYear(year);
  }, []);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: "Monthly Target",
        align: "start",
        font: {
          size: 20,
        },
      },
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          let value = context.raw;
          return `${value.toLocaleString()} sqft`; // Append sqft to the value
        },
      },
    },
    scales: {
      x: {
        display: true,
        grid: {
          display: false,
        },
        ticks: {
          color: "#000",
          angle: 90,
          callback: function (value) {
            const label = this.getLabelForValue(value);
            return label.length > 10 ? label.substring(0, 10) + "..." : label;
          },
        },
        stacked: true,
      },
      y: {
        title: {
          text: "Sq feet",
          display: true,
        },
        grid: {
          display: true,
        },
        display: true,
        stacked: true,
        ticks: {
          color: "#000",
          callback: function (value) {
            if (value === 0) {
              return value;
            }
            return value / 1000 + "k";
          },
        },
      },
    },
  };

  useEffect(() => {
    fetchChartData();
  }, []);
  const getBarColor = (value, target) => {
    let compare1 = parseInt(value);
    let compare2 = parseInt(target);

    return compare1 >= compare2 ? "#399E79" : "rgba(238, 108, 77)";
  };

  const fetchChartData = async () => {
    try {
      const response = await DasboardService.getMonthlyTargetByTeam(selectedMonth, currentYear)
      const teamsData = response.data;

      const responseTargetValue = await DasboardService.getMonthlyTargetValue(selectedMonth, currentYear)
      setTargetValueOfTheMonth(responseTargetValue.data.targetValue);

      const labels = teamsData.map((team) => team.teamName);
      const targetValues = teamsData.map((team) => team.totalSquareFeet || 0);

      const data = {
        labels,
        datasets: [
          {
            data: targetValues,
            backgroundColor: targetValues.map((value) =>
              getBarColor(value, responseTargetValue.data.targetValue)
            ),
            barThickness: 25,
          },
        ],
      };

      setChartData(data);
    } catch (error) {
      console.error("Error fetching chart data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchChartData();
  }, [selectedMonth]); // Fetch new data when the month changes

  const handleTargetValueSubmit = async (e) => {
    try {
      // Submit target value to your backend API
      await DasboardService.postTargetValue(targetValueOfTheMonth);

      // await axios.post(
      //   "https://client-glfunnel-service-144135692330.asia-south1.run.app/api/v1/createMonthlyTarget",
      //   {
      //     targetValue: targetValueOfTheMonth,
      //   }
      // );


      showSuccessToast("Target value submitted successfully!");
      setIsEditing(false);
    } catch (error) {
      console.error("Error submitting target value:", error);
    }
  };
  // useEffect (()=>{
  //   handleTargetValueSubmit()
  // },[])

  const [isEditing, setIsEditing] = useState(false);

  const handleEditClick = () => {
    setIsEditing(true); // Enable editing mode when pencil icon is clicked
  };

  const handleCancelClick = () => {
    setTargetValue(""); // Reset the input value
    setIsEditing(false); // Exit editing mode
  };
  const userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData?.user?.role;
  return (
    <>
      <ToastContainer />
      <div className="shadow-md  w-full 4xl:h-[590px] h-auto pb-10 rounded-lg bg-white pt-5">
        <div className=" h-full px-6 4xl:ml-36">
          {view == "dashboard" && (
            <div>
              {(userRole === "Admin" || userRole === "CMO") && (
                <div className=" ">
                  <form
                    onSubmit={handleTargetValueSubmit}
                    className="mb-4 mt-4 px-5 flex justify-between"
                  >
                    <select
                      value={selectedMonth}
                      onChange={(e) => setSelectedMonth(e.target.value)}
                      className="mr-2 p-2 border rounded  xl:w-28 xl:h-10"
                    >
                      {months.map((month) => (
                        <option key={month.value} value={month.value}>
                          {month.label}
                        </option>
                      ))}
                    </select>
                    {/* <input
            type="number"
            value={targetValue}
            onChange={(e) => setTargetValue(e.target.value)}
            placeholder="Enter target value"
            className="mr-2 p-2 border rounded"
            required
          />
          <button type="submit" className="p-2 bg-blue-500 text-white rounded">
            Submit Target
          </button> */}

                    <div className="flex items-center gap-4">
                      <h1 className="font-semibold text-xl xl:text-sm whitespace-nowrap">
                        Current Month Target:
                      </h1>
                      <input
                        type="number"
                        value={targetValueOfTheMonth}
                        onChange={(e) =>
                          setTargetValueOfTheMonth(e.target.value)
                        }
                        placeholder="Enter target value"
                        className={`p-2 border rounded xl:w-28 xl:h-8 ${
                          isEditing ? "mr-2" : "mr-4" // Adjust the margin based on edit mode
                        }`}
                        disabled={!isEditing} // Disable the input when not in edit mode
                      />
                      {isEditing ? (
                        <div className="flex  gap-5">
                          <img
                            src={icon.checkIcon}
                            alt=""
                            onClick={handleTargetValueSubmit}
                          />
                          <img
                            src={icon.cancelIcon}
                            alt=""
                            onClick={handleCancelClick}
                          />
                        </div>
                      ) : (
                        <img
                          className="w-4"
                          src={icon.pencilIcon}
                          alt=""
                          onClick={handleEditClick}
                        />
                      )}
                    </div>
                  </form>
                </div>
              )}
            </div>
          )}

          <Bar options={options} data={chartData} />
        </div>
      </div>
    </>
  );
};

export default StackedBarChart;
